// ink-component
import React, { HTMLAttributes } from 'react';
import getGlobalProps from '../../../../helpers/constants/global-props';
import Heading from '../../../Typography/Heading/Heading';
import useSunsetWarning from '../../../../hooks/useSunsetWarning';

export interface PageTitleProps extends HTMLAttributes<HTMLHeadingElement> {}

const globalProps = getGlobalProps({ sunset: true });

/**
 * @purpose Exposes and summarizes page purpose
 * @group Page
 * @status sunset
 * @replacementComponent Heading
 * @parents Page.Header
 */
function PageTitle(props: PageTitleProps) {
  const { className, style, children, ...otherProps } = props;

  useSunsetWarning({ componentName: 'PageTitle', substitute: 'Heading' });

  return (
    <div {...otherProps} {...globalProps}>
      <Heading variant="heading-1">{children}</Heading>
    </div>
  );
}

PageTitle.displayName = 'Page.Title';

export default PageTitle;
